import { useEffect, useState } from 'react'

const DROPDOWN_HEIGHT = 200
const SPACING = 4

type Coords = { top: number; left: number }

export const useDropdownPosition = (
  ref: React.RefObject<HTMLElement>,
  isOpen: boolean
): Coords => {
  const [coords, setCoords] = useState<Coords>({ top: 0, left: 0 })

  useEffect(() => {
    if (!isOpen || !ref.current) return

    const rect = ref.current.getBoundingClientRect()

    const fitsBelow =
      rect.bottom + DROPDOWN_HEIGHT + SPACING < window.innerHeight
    const fitsAbove = rect.top - DROPDOWN_HEIGHT - SPACING > 0

    let top: number
    if (fitsBelow) {
      top = rect.bottom + SPACING
    } else if (fitsAbove) {
      top = rect.top - DROPDOWN_HEIGHT - SPACING
    } else {
      top = Math.max(window.innerHeight - DROPDOWN_HEIGHT - SPACING, 0)
    }

    setCoords({
      top,
      left: rect.left
    })
  }, [isOpen, ref.current])

  return coords
}
